module.exports = __webpack_public_path__ + "img/espace_perso.1029e837.jpg";